import React, { PureComponent } from 'react';
import { object } from 'prop-types';
import styled from 'styled-components';
import NeighborhoodLinks from './NeighborhoodLinks';
import { colors } from '../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../constants/text';
import { isEmptyArray } from '../../../../core/util/array';
import { INFO_FIELD_DEFAULT_STATE } from '../../../../constants/clinicDetailPage';
import { smallerThan } from '../../../../core/util/styledComponents';

const Root = styled.div`
  margin-bottom: 22px;
  list-style: none;
  padding: 0;
`;

const Row = styled.li`
  display: flex;
  padding: 5px 0;
  border-bottom: ${colors.greyDim} 1px solid;
  justify-content: space-between;
`;

const Item = styled.div`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  color: ${colors.blueMonday};
  text-align: left;
`;

const RightItem = styled(Item)`
  width: 76%;

  ${smallerThan.sm`
    width: 50%;
  `}
`;

export default class AdditionalInfo extends PureComponent {
  static propTypes = {
    location: object,
  };

  render = () => {
    const { neighborhoods, crossStreets, parkingDetails } = this.props.location;

    if (isEmptyArray(neighborhoods) && !crossStreets && !parkingDetails) {
      return null;
    }

    return (
      <Root>
        <Row>
          <Item>Neighborhoods</Item>
          <RightItem>
            <NeighborhoodLinks neighborhoods={neighborhoods} />
          </RightItem>
        </Row>
        <Row>
          <Item>Cross Streets</Item>
          <RightItem itemProp={crossStreets ? 'address' : undefined}>
            {crossStreets || INFO_FIELD_DEFAULT_STATE}
          </RightItem>
        </Row>
        <Row>
          <Item>Parking Details</Item>
          <RightItem>{parkingDetails || INFO_FIELD_DEFAULT_STATE}</RightItem>
        </Row>
      </Root>
    );
  };
}
